<div
  class="shadcn-card rounded-xl border bg-card border-card-border text-card-foreground shadow-sm"
>
  <ng-content></ng-content>
</div>
